<script setup lang="ts">
import ButtonTop from '@/components/button/ButtonTop.vue'
import Footer from '@/components/main/Footer.vue'
import Header from '@/components/main/Header.vue'
import { defineAsyncComponent } from 'vue'
import LoadingHandler from './loading/LoadingHandler.vue'

const AlertClearBasket = defineAsyncComponent(
    () => import('@/components/alert/AlertClearBasket.vue')
)
const AlertDeleteElement = defineAsyncComponent(
    () => import('@/components/alert/AlertDeleteElement.vue')
)
const AlertBasketLogin = defineAsyncComponent(
    () => import('@/components/alert/AlertBasketLogin.vue')
)
const SectionOverlay = defineAsyncComponent(
    () => import('@/components/alert/SectionOverlay.vue')
)

const AlertTableQrCode = defineAsyncComponent(
    () => import('@/components/alert/AlertTableQrCode.vue')
)

const SectionOrder = defineAsyncComponent(
    () => import('@/components/section/SectionOrder.vue')
)
</script>

<template>
    <section class="w-full h-screen flex flex-col justify-between">
        <div class="w-full flex flex-col items-center">
            <Header />

            <SectionOverlay />

            <AlertDeleteElement />
            <AlertClearBasket />
            <AlertBasketLogin />

            <SectionOrder />

            <LoadingHandler />
        </div>

        <ButtonTop />

        <AlertTableQrCode />

        <Footer />
    </section>
</template>
